import { COLOR_PALETTE } from '../colors/colorPalette.js';

// Dummy import to make sure global and theme css is extracted in build
/**
 * Helper for typing theme color variant selectors.
 * Used to enforce the typing where a `string` type may be the only value option
 */ const ThemeColorKey = (key)=>key;
const NEXTGEN_THEME = {
    THEME_CONTEXT: "BASE",
    PORTAL_LAYER: 0,
    COLORS: {
        contextDark60: COLOR_PALETTE.blurpleDark60,
        contextDark20: COLOR_PALETTE.blurpleDark20,
        contextDark10: COLOR_PALETTE.blurpleDark10,
        context: COLOR_PALETTE.blurple100,
        context60: COLOR_PALETTE.blurple60,
        context30: COLOR_PALETTE.blurple30,
        context10: COLOR_PALETTE.blurple10
    }
};
const OPTIGO_THEME = {
    THEME_CONTEXT: "OPTIGO",
    PORTAL_LAYER: 0,
    COLORS: {
        contextDark60: COLOR_PALETTE.optiBlueDark60,
        contextDark20: COLOR_PALETTE.optiBlueDark20,
        contextDark10: COLOR_PALETTE.optiBlueDark10,
        context: COLOR_PALETTE.optiBlue100,
        context60: COLOR_PALETTE.optiBlue60,
        context30: COLOR_PALETTE.optiBlue30,
        context10: COLOR_PALETTE.optiBlue10
    }
};
const THEME_CONTEXT_MAP = {
    BASE: NEXTGEN_THEME,
    OPTIGO: OPTIGO_THEME
};
const useThemeContext = (themeContext = "BASE")=>{
    return THEME_CONTEXT_MAP[themeContext];
};

export { ThemeColorKey, useThemeContext };
